import { serializable, primitive, object, alias } from 'serializr';
import { Sector } from './sector.model';
import { Size } from './size.model';
import { CompanyType } from './companyType.model';

export class ParentCompanySetup {
  @serializable(primitive())
  id?: number;

  @serializable(primitive())
  name?: string;

  @serializable(object(Size))
  size?: Size;

  @serializable(object(Sector))
  sector?: Sector;

  @serializable(alias('company_type', object(CompanyType)))
  companyType?: CompanyType;

  @serializable(alias('organizational_boundary', primitive()))
  organizationalBoundary?: string;

  @serializable(alias('reporting_month', primitive()))
  reportingMonth?: number;

  @serializable(alias('baseline_year', primitive()))
  baselineYear?: number;

  @serializable(alias('recalculation_threshold', primitive()))
  recalculationThreshold?: number;

  @serializable(alias('has_locations', primitive()))
  hasLocations?: boolean;
}
